import type { StoreApi, UseBoundStore } from 'zustand';
import { createJSONStorage, persist, type StateStorage } from 'zustand/middleware';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface TradeTermsAcceptanceState {
  acceptedUserIds: Record<string, true>;
  hasAccepted: (userId: string) => boolean;
  markAccepted: (userId: string) => void;
}

function getUsableLocalStorage(): Storage | null {
  const storage = globalThis.localStorage;
  if (
    storage === undefined ||
    typeof storage.getItem !== 'function' ||
    typeof storage.setItem !== 'function' ||
    typeof storage.removeItem !== 'function'
  ) {
    return null;
  }
  return storage;
}

const SAFE_STORAGE: StateStorage = {
  getItem: (name: string): string | null => getUsableLocalStorage()?.getItem(name) ?? null,
  setItem: (name: string, value: string): void => {
    getUsableLocalStorage()?.setItem(name, value);
  },
  removeItem: (name: string): void => {
    getUsableLocalStorage()?.removeItem(name);
  },
};

export const useTradeTermsAcceptanceStore: UseBoundStore<StoreApi<TradeTermsAcceptanceState>> =
  createTrackedStore<TradeTermsAcceptanceState>('useTradeTermsAcceptanceStore')(
    persist(
      (set, get) => ({
        acceptedUserIds: {},
        hasAccepted: (userId: string): boolean => Boolean(get().acceptedUserIds[userId]),
        markAccepted: (userId: string): void => {
          if (get().acceptedUserIds[userId]) return;
          set((state) => ({
            acceptedUserIds: { ...state.acceptedUserIds, [userId]: true },
          }));
        },
      }),
      {
        name: 'morfi-trade-terms-acceptance',
        storage: createJSONStorage(() => SAFE_STORAGE),
      },
    ),
  );
